module.exports = __webpack_public_path__ + "img/tx-_0000s_0006_7.b6e57947.png";